// extracted by mini-css-extract-plugin
module.exports = {"attributeLabel":"CharacteristicsDetail_attributeLabel__v0YZ0","attributeWrapper":"CharacteristicsDetail_attributeWrapper__1MyBQ"};